export default __webpack_public_path__ + "static/media/patreon.be2186e7.svg";